import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HomeBgItem from "./HomeBgItem";
import Button from "../common/Button";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { AsVo } from "src/vo/asVo";
import moment from "moment";

const ComVisitItem = () => {
  const navigate = useNavigate();
  const [isRequest, setIsRequest] = useState(true);

  const asHopeList: any = useAppSelector((state) => state.homeReduce.asHopeDataList);

  useEffect(() => {
    if (asHopeList) {
      if (asHopeList.length > 0) {
        setIsRequest(true);
      } else {
        setIsRequest(false);
      }
    }
  }, [asHopeList]);

  const dateFormater = (date: string) => {
    if (date) {
      if (date.length === 10) {
        let formater = date.substring(5, 10);
        if (formater.indexOf("-") > -1) {
          formater = formater.replace("-", "/");
        }
        return formater;
      } else {
        return "202020";
      }
    }
  };

  const completeReportMove = (asIndex: string | undefined) => {
    navigate("/report-register/" + asIndex, { replace: true });
  };

  const changeBrandCode = (code: string | undefined) => {
    if (code === undefined) return;

    let value = "";

    if (code.toUpperCase().startsWith("M")) {
      value = "MLB";
    } else if (code.toUpperCase().startsWith("X")) {
      value = "Discovery";
    } else if (code.toUpperCase().startsWith("I")) {
      value = "MLB KIDS";
    } else if (code.toUpperCase().startsWith("A")) {
      value = "STRETCH ANGELS";
    } else if (code.toUpperCase().startsWith("V")) {
      value = "DUVETICA";
    } else if (code.toUpperCase().startsWith("ST")) {
      value = "Sergio Tacchini";
    } else {
      value = "SUPRA";
    }

    return value;
  };

  return (
    <>
      {isRequest ? (
        <>
          {asHopeList?.map((info: AsVo, idx: any) => (
            <HomeBgItem key={idx}>
              <Link to={"/as-detail/" + info.as_idx}>
                <div>
                  <p className="title">
                    <span className="brand_name">{changeBrandCode(info.store_id)}</span>
                    {info.store_name}
                  </p>
                  <p className="text">{info.contents}</p>
                  <p className="date">{info.insert_date ? moment(info.insert_date).format("YYYY.MM.DD") : "-"}</p>
                </div>
                {info.visit_date && (
                  <div className="status">
                    {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                    <p className="active">{moment(info.visit_date).format("M/DD ddd")}</p>
                    {/* <p className="active">{dateFormater(info.visit_date)}</p> */}
                  </div>
                )}
              </Link>
              {new Date(String(info.visit_date)) <= new Date(moment(new Date()).format("YYYY-MM-DD")) && (
                <Button variant="contained" br="round" onClick={() => completeReportMove(info.as_idx)}>
                  완료보고 등록
                </Button>
              )}
            </HomeBgItem>
          ))}
        </>
      ) : (
        <HomeBgItem>
          <p className="noData">방문예정인 A/S건이 없습니다.</p>
        </HomeBgItem>
      )}
    </>
  );
};

export default ComVisitItem;
